import {
    APP_CHECK_VIEW_PORT,
    LOAD_FORM_STATE,
    FORM_STATE_LOADED,
    SAVE_APPSTATE_REQUEST,
    SAVE_APPSTATE_SUCCESS,
    SAVE_APPSTATE_FAILURE,
    APP_LOAD_FAILED
} from './types';

import axios from 'axios';
import * as helpers from "../helpers/actionsHelpers";

const postForState = (formData, postUrl, putUrl, data, state, dispatch) => {

  const options = {
      method: 'POST',
      data: formData,
      headers: { 'Content-Type': 'application/json' },
      url: postUrl
  }
  const instance = axios.create();
  instance.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      if (!error.response) {
        dispatch({
          type: SAVE_APPSTATE_FAILURE,
          payload: {
            code: "No Internet Connection",
            message: [{"message": "Please check your internet connection"}]
          }
        });
       }
      return Promise.reject(error);
    }
  );      

  instance(options)
  .then(function (response) {
    if (response.data.code) {
      //failed
      dispatch({
        type: SAVE_APPSTATE_FAILURE,
        payload: {
          code: response.data.code || '',
          message: response.data.message || ''
        }
      });        
    } else {

      dispatch({
        type: SAVE_APPSTATE_SUCCESS,
        payload: response.data         
      });

      const putFormData = new FormData();
      const putData = helpers.prepareDraftDataAPI({...data}, response.data.id, state.service.attachments, state.service.quoteResponse);
      putFormData.append("data", JSON.stringify(putData));
      putFormData.append("email", response.data.email);
      putFormData.append("secret", response.data.secret);      
      putForState(putFormData, putUrl, dispatch);
    }
  })
  .catch(function (error) {
    dispatch({
      type: SAVE_APPSTATE_FAILURE,
      payload: {
        code: error.response.data.code || '',
        message: error.response.data.message || ''
      }
    });
  });  
}

const putForState = (formData, url, dispatch) => {
  const options = {
      method: 'POST',
      data: formData,
      headers: { 'Content-Type': 'application/json' },
      url: url
  }

  const instance = axios.create();
  instance.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      if (!error.response) {
        dispatch({
          type: SAVE_APPSTATE_FAILURE,
          payload: {
            code: "No Internet Connection",
            message: [{"message": "Please check your internet connection"}]
          }
        });
       }
      return Promise.reject(error);
    }
  );      

  instance(options)
  .then(function (response) {
    if (response.data.code) {
      //failed
      dispatch({
        type: SAVE_APPSTATE_FAILURE,
        payload: {
          code: response.data.code || '',
          message: response.data.message || ''
        }
      });        
    } else {
      dispatch({
        type: SAVE_APPSTATE_SUCCESS,
        payload: response.data          
      });

      // remove window onbeforeunload
      window.onbeforeunload = function () {}

      // scroll to to top of page
      document.getElementById("hero-app").scrollIntoView({behavior: 'smooth'});

    }
  })
  .catch(function (error) {
    dispatch({
      type: SAVE_APPSTATE_FAILURE,
      payload: {
        code: error.response.data.code || '',
        message: error.response.data.message || ''
      }
    });
  });  
}

export const checkViewPort = desktopBreakPoint => {
    const isMobile = !desktopBreakPoint.matches;
    return {
        type: APP_CHECK_VIEW_PORT,
        payload: isMobile
    }
};

export const saveAppState = (data, form) => async (dispatch, getState) => {

    const postUrl = ((process.env.NODE_ENV === "development") ? process.env.REACT_APP_HOST_URL : window.location.origin) + 
      `/_webservices/heritage/draft/create`

    const putUrl = ((process.env.NODE_ENV === "development") ? process.env.REACT_APP_HOST_URL : window.location.origin) + 
      `/_webservices/heritage/draft/save`


    const postData = {
        "formTemplateName": form,
        "formTemplateDescription": "",
        "formTemplateUrl": window.location.origin + "/continue-application",
        "formTemplateEmailTemplate": "HERITAGE",
        "email": data.form[form].values.primaryContact.email,
        "name": "",
        "description": ""
    }

    const putData = helpers.prepareDraftDataAPI({...data}, getState().service.id, getState().service.attachments, getState().service.quoteResponse);

    const postFormData = new FormData();
    postFormData.append("data", JSON.stringify(postData));

    const putFormData = new FormData();
    putFormData.append("data", JSON.stringify(putData));
    putFormData.append("email", data.form[form].values.primaryContact.email);
    putFormData.append("secret", data.service.secret);

    if (data) {

        dispatch({
            type: SAVE_APPSTATE_REQUEST
        });

        // PUT - exist - just update
        if (data.service.id) {
          putForState(putFormData, putUrl, dispatch);
        } else {
          // POST - create and save (PUT)
          postForState(postFormData, postUrl, putUrl, data, getState(), dispatch);
        }
      }

};

export const loadFormState = (data) => {
    return {
        type: LOAD_FORM_STATE,
        payload: data
    }
};

export const formStateLoaded = () => {
    return {
        type: FORM_STATE_LOADED
    }
};

export const faildAppLoad = (message) => {
    return {
        type: APP_LOAD_FAILED,
        payload: message
    }
}

